import css from 'styled-jsx/css';

const styles = css.global`.trend-popover__container{display:flex;flex-direction:row;height:24px;margin-left:-2px;margin-bottom:15px}.trend-popover__close-button{position:absolute;top:10px;right:10px;cursor:pointer}.trend-popover__title-text{font-size:13px;font-weight:700;line-height:13px;color:#262626;margin-bottom:15px}.trend-popover__body-text{font-size:13px;font-weight:400;line-height:1.46;color:#262626}`;

export default styles;